export default {
  title: 'CORPORATE PROFILE',
  items: {
    CorporateApproveEmails: {
      label: 'Recipient for new signup',
      type: 'string',
      unit: ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/corporate-profile.js